import AsyncStorage from "@react-native-community/async-storage";
import React, { useEffect, useState } from "react";
import {
  Dimensions,
  ImageBackground,
  Modal,
  ScrollView,
  Text,
  TouchableOpacity,
  View
} from "react-native";

import ReactMarkdown from "react-markdown";
import { getRecursText, getRecursURL } from "../../Functions/getRecurs";
import globalstyle from "../../Styles/Globals/globals";
import style from "../../Styles/premi";
import Menu from "../menu";
import PremiMultimedia from "./PremiMultimedia";

function Premi(RouterData) {
  const { poi, projecte, itinerari, recursos, idioma, currentItinerari } =
    RouterData.route.params;

  const poiData = itinerari.pois.find((e) => e.id === poi.id);
  const currentPremi = projecte.premis.find((e) => e.id === poiData.premi);
  const currentPoi = currentItinerari.pois.find((e) => e.id === poi.id);
  
  const [modalPistafuturaVisible, setModalPistafuturaVisible] = useState(false);
  const [pistafuturaText, setPistafuturaText] = useState("");

  useEffect(() => {
    if (currentPoi.isLast) {
      currentItinerari.finalitzat = true;
    }
    currentPoi.done = true;
    currentItinerari.puntsTotals =
      parseInt(currentItinerari.puntsTotals) + parseInt(currentPoi.punts);
    currentItinerari.currentOrder = currentItinerari.currentOrder + 1;

    AsyncStorage.setItem(
      "itinerari" + itinerari.id,
      JSON.stringify(currentItinerari),
    );

    AsyncStorage.getItem("puntsTotals").then((punts) => {
      if (punts == null) {
        AsyncStorage.setItem(
          "puntsTotals",
          currentItinerari.puntsTotals.toString(),
        );
      } else {
        AsyncStorage.setItem(
          "puntsTotals",
          (parseInt(punts) + parseInt(currentPoi.punts)).toString(),
        );
      }
    });
  }, []);

  const saltarTrucada = () => {
    RouterData.navigation.navigate("PreviTrucada", RouterData.route.params);
  };

  const handleContinuar = () => {
    // if (currentPoi && currentPoi.isLast) {
    //   saltarTrucada();
    //   return;
    // }

    const pistafutura = currentPremi && currentPremi["pistafutura" + idioma];
    
    if (pistafutura && typeof pistafutura === "string" && pistafutura.trim() !== "") {
      setPistafuturaText(pistafutura);
      setModalPistafuturaVisible(true);
    } else {
      RouterData.navigation.navigate("Mapa", RouterData.route.params);
    }
  };

  const handleAceptarPistafutura = () => {
    setModalPistafuturaVisible(false);
    RouterData.navigation.navigate("Mapa", RouterData.route.params);
  };

  {
    /* Es fa servir amb projectes sense cenobify (per google analytics) */
  }
  const sendToAnalitycs = async () => {
    Analytics.logEvent(
      "Posta_" + this.state.currentStateItinerari.currentOrder,
      {
        screen: "Posta_" + this.state.currentStateItinerari.currentOrder,
        purpose:
          "Ha acabat el premi " + this.state.currentStateItinerari.currentOrder,
      },
    );
  };

  return (
    <View
      style={{
        flex: 1,
        width: "100%",
        height: "100%",
        maxHeight: Dimensions.get("screen").height,
        maxWidth: "100%",
      }}
    >
      <ImageBackground
        source={{
          uri: getRecursURL(recursos, "background_default", idioma),
        }}
        style={{ flex: 1 }}
      >
        {/* Bocata has guanyat/puntuacio */}
        <View
          style={{ flex: 20, justifyContent: "center", alignItems: "center" }}
        >
          {/*<Text*/}
          {/*  style={{*/}
          {/*    color: "#403d27",*/}
          {/*    fontSize: "2vh",*/}
          {/*    fontWeight: "bold",*/}
          {/*    textAlign: "center",*/}
          {/*    width: "70%",*/}
          {/*    fontFamily: "Gothic",*/}
          {/*  }}*/}
          {/*>*/}
          {/*  {currentPremi["Nom" + idioma]}*/}
          {/*</Text>*/}
          <ImageBackground
            source={{
              uri: getRecursURL(recursos, "bocata_premi", idioma),
            }}
            style={{
              flex: 1,
              width: "100%",
              alignItems: "center",
              alignSelf: "center",
              justifyContent: "center",
              height: "100%",
            }}
            resizeMode={"contain"}
          >
            <View
              style={{
                alignItems: "center",
                alignSelf: "center",
                justifyContent: "center",
                paddingTop: 6,
              }}
            >
              <Text style={style.textPremi}>
                {getRecursText(recursos, "guanyar", idioma)}
              </Text>
              <Text style={style.punts}>
                {currentPoi.punts}/{currentPremi.punts || 100}
              </Text>
              <Text style={style.textPremi}>
                {getRecursText(recursos, "total_itinerari", idioma)}
              </Text>
              <Text style={style.punts}>
                {currentItinerari.puntsTotals + currentPoi.punts}/
                {currentItinerari.puntsItinerari}
              </Text>
            </View>
          </ImageBackground>
        </View>

        {/* Image iframe */}
        <View style={{ flex: 3.5 }}>
          {/* this should be a title and*/}
          <Text style={style.titlePremi}>{currentPremi["Nom" + idioma]}</Text>
        </View>  
              <View
          style={{
            flex: 35,
            justifyContent: "center",
            width: "80%",
            height: "70%",
            alignSelf: "center",
          }}
        >
          {PremiMultimedia(currentPremi, true)}
        </View>
        {/* Text */}
        <View style={{ flex: 2.5 }} />
        <View style={[{ flex: 20, alignItems: "center" }]}>
          <ScrollView style={{ flexGrow: 1, width: "90%", height: "100%" }}>
            <View
              style={[
                style.descriptionContainer,
                { flexGrow: 1, width: "100%", height: "100%" },
              ]}
            >
              <ReactMarkdown>
                {currentPremi["descripcioPremiDetallat" + idioma]}
              </ReactMarkdown>
            </View>
          </ScrollView>
        </View>

        {/* Boto continuar */}
        <View style={{ flex: 10, justifyContent: "center" }}>
          <TouchableOpacity
            onPress={()=>handleContinuar()}
            activeOpacity={0.7}
          >
            <Text style={globalstyle.botoContinuar}>
              {getRecursText(recursos, "text_continuar", idioma)}
            </Text>
          </TouchableOpacity>
        </View>

        {/* Menu */}
        <View style={{ flex: 10 }}><Menu projecte={RouterData.route.params}></Menu></View>
      </ImageBackground>

      {/* Modal pistafutura */}
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalPistafuturaVisible}
        onRequestClose={handleAceptarPistafutura}
      >
        <View
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <View
            style={{
              backgroundColor: "white",
              borderRadius: 10,
              padding: 20,
              width: "80%",
              maxWidth: 400,
              alignItems: "center",
            }}
          >
            <ScrollView style={{ maxHeight: 300, marginBottom: 20 }}>
              <Text style={{ fontSize: 16, textAlign: "center" }}>
                {pistafuturaText}
              </Text>
            </ScrollView>
            <TouchableOpacity
              onPress={handleAceptarPistafutura}
              style={{
                backgroundColor: "#006fb7",
                paddingHorizontal: 30,
                paddingVertical: 10,
                borderRadius: 5,
              }}
            >
              <Text style={{ color: "white", fontSize: 16, fontWeight: "bold" }}>
                {getRecursText(recursos, "text_continuar", idioma)}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
    </View>
  );
}

export default Premi;
